import { call, put, takeLatest } from "redux-saga/effects";
import { searchTrainersApi } from "../../../api/trainers";
import { IBaseResponse } from "../../../interfaces/base";
import { IFetchTrainersAction } from "../../../interfaces/store/trainers-interfaces";
import {
  fetchTrainersSuccess,
  fetchTrainersFailed,
  fetchTrainersStart,
} from "./trainers-slice";

function* _fetchTrainers({ payload }: IFetchTrainersAction) {
  try {
    const { sort, pagination, search } = payload;

    const response: IBaseResponse = yield call(searchTrainersApi, {
      sort: sort || { sortBy: "updatedAt", sortOrder: -1 },
      search,
      pagination,
      filter: { role: "trainer", deleted: false },
    });

    if (response.error) {
      yield put(fetchTrainersFailed(response.error));
    } else {
      yield put(fetchTrainersSuccess({ data: response.data }));
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(fetchTrainersFailed({ message: error.message }));
  }
}

function* trainersSaga() {
  yield takeLatest(fetchTrainersStart.type, _fetchTrainers);
}

export default trainersSaga;
